/* stylelint-disable selector-type-case */
/* stylelint-disable selector-type-no-unknown */

import styled from 'styled-components';

import { Input as Text } from 'pods/forms/components/inputs/Text/Text.style';
import { SelectContainer as Select } from 'pods/forms/components/inputs/Select/Select.style';
import { TextArea } from 'pods/forms/components/inputs/TextArea/TextArea.style';
import {
	CtrlHolder,
	FieldContents,
} from 'pods/forms/components/structural/UpdatedCtrlHolder/UpdatedCtrlHolder.style';

export const Wrapper = styled.div`
	/* All of these consume 'baseInputStyles()' from Text.style.ts,
	which sets the max-width of the shared input styles */
	${Text},
	${Select} .formBuilder__select,
	${TextArea},
	${FieldContents}
	 {
		max-width: unset !important;
	}

	${CtrlHolder} {
		margin-bottom: 0;
	}
`;

export const FieldSet = styled.fieldset`
	border: none;
	padding: 0;
	margin: 0;

	legend {
		display: inline;
		position: static;
		margin: 0;
	}
`;
